import { render } from "./DesktopActions.vue?vue&type=template&id=ecfc84a6"
import script from "./DesktopActions.vue?vue&type=script&lang=js"
export * from "./DesktopActions.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__